/**
 * @generated SignedSource<<e61cf0882691d8efe6ff1ea7f4bfb1ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PageAttachmentInput = {
  file: FileInput;
};
export type FileInput = {
  uploadToken: string;
};
export type UploadFileHandler_addAttachmentsToPage_Mutation$variables = {
  attachments: ReadonlyArray<PageAttachmentInput>;
  pageId: string;
};
export type UploadFileHandler_addAttachmentsToPage_Mutation$data = {
  readonly addAttachmentsToPage: {
    readonly attachmentsAdded: ReadonlyArray<{
      readonly __typename: "PageAttachment";
      readonly id: string;
      readonly item: {
        readonly __typename: "File";
        readonly id: string;
        readonly mimeType: string;
        readonly name: string;
        readonly size: number;
        readonly url: URIString;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      };
    }>;
  } | null;
};
export type UploadFileHandler_addAttachmentsToPage_Mutation = {
  response: UploadFileHandler_addAttachmentsToPage_Mutation$data;
  variables: UploadFileHandler_addAttachmentsToPage_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "attachments"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "attachments",
        "variableName": "attachments"
      },
      {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "size",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mimeType",
      "storageKey": null
    }
  ],
  "type": "File",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UploadFileHandler_addAttachmentsToPage_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PagesAddAttachmentsMutationPayload",
        "kind": "LinkedField",
        "name": "addAttachmentsToPage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageAttachment",
            "kind": "LinkedField",
            "name": "attachmentsAdded",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "item",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UploadFileHandler_addAttachmentsToPage_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PagesAddAttachmentsMutationPayload",
        "kind": "LinkedField",
        "name": "addAttachmentsToPage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageAttachment",
            "kind": "LinkedField",
            "name": "attachmentsAdded",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "item",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d62ee2542cff83dd83d3bb40cbc16e6f",
    "id": null,
    "metadata": {},
    "name": "UploadFileHandler_addAttachmentsToPage_Mutation",
    "operationKind": "mutation",
    "text": "mutation UploadFileHandler_addAttachmentsToPage_Mutation(\n  $pageId: ID!\n  $attachments: [PageAttachmentInput!]!\n) {\n  addAttachmentsToPage(input: {pageId: $pageId, attachments: $attachments}) {\n    attachmentsAdded {\n      __typename\n      id\n      item {\n        __typename\n        ... on File {\n          id\n          name\n          url\n          size\n          mimeType\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "21ea8f789d571e1961ab16d3f9d13c77";

export default node;
